<template>
  <b-row class="my-3" align-v="center">
    <b-col :sm="labelWidth" class="text-left">
      <label class="mb-0 align-middle font-weight-bold">{{this.label}}</label>
    </b-col>
    <b-col :sm="inputWidth">
  		<span class="FITTextContent">{{content}}</span>
	</b-col>
  </b-row>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'

export default {
  name: 'FITTextRow',
  props: {
    label: String,
    width: {
      type: Number,
      default: 10
    },
    content:[String,Number]
  },
  data() {
    return {
      inputWidth: this.width
    }
  },
  mounted() {
    this.labelCheck(this.label);
  },
  computed: {
    labelWidth() {
      return 12 - this.inputWidth;
    }
  },
  methods: {
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    change(event) {
      this.$emit('input', event);
    }
  }
}

</script>
<style type="text/css">
	.FITTextContent{
		font-size:0.9rem;
		font-weight: 400 !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/Form/FITTextRow.vue